/**
 * src/api/client.js
 * Axios con auth por JWT (Bearer). El token maestro estático ya no vive en el
 * navegador: el panel se autentica con el JWT de sesión de un usuario admin.
 */
import axios from 'axios'
import { useAuthStore } from '../store/authStore.js'

const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000'

export const api = axios.create({
  baseURL: BASE_URL,
  timeout: 30_000,
  headers: { 'Content-Type': 'application/json' },
})

api.interceptors.request.use((config) => {
  const { token } = useAuthStore.getState()
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
  }
  return config
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      useAuthStore.getState().logout()
      window.location.href = '/login'
      return Promise.reject(error)
    }
    if (!error.response) {
      const networkErr = new Error('No se pudo conectar con el servidor. Verifica tu conexión.')
      networkErr.isNetworkError = true
      networkErr.original = error
      return Promise.reject(networkErr)
    }
    if (error.response.status >= 500) {
      const serverErr = new Error(`Error del servidor (${error.response.status}). Inténtalo de nuevo.`)
      serverErr.isServerError = true
      serverErr.status = error.response.status
      serverErr.data = error.response.data
      return Promise.reject(serverErr)
    }
    return Promise.reject(error)
  }
)

export default api
